import { render, staticRenderFns } from "./ResultFactor.vue?vue&type=template&id=d6897dd4&scoped=true&"
import script from "./ResultFactor.vue?vue&type=script&lang=js&"
export * from "./ResultFactor.vue?vue&type=script&lang=js&"
import style0 from "./ResultFactor.vue?vue&type=style&index=0&id=d6897dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6897dd4",
  null
  
)

export default component.exports